export default {
  NUMERIC: "numeric",
  ALPHANUMERIC: "alphanumeric",
  DATE: "date",
};
